module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("emoji-invoker", null, {
    "events": {
      click: function (e) { return _vm.toggle(e); }
    }
  }), _vm._v(" "), (_vm.display.visible) ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hide),
      expression: "hide"
    }]
  }, [_vm._t("emoji-picker", null, {
    "emojis": _vm.emojis,
    "insert": _vm.insert,
    "display": _vm.display
  })], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d3b080a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/EmojiPicker.vue
// module id = 5
// module chunks = 0